import { render, staticRenderFns } from "./incomingInspection.vue?vue&type=template&id=2f224300"
import script from "./incomingInspection.vue?vue&type=script&lang=js"
export * from "./incomingInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports